import AcquisitionTrackerPageSkeleton from './AcquisitionTrackerPageSkeleton'
import Page from './Page'
import { useAcquisitionTrackerPageState } from './state/useAcquisitionTrackerPageState'
import { useAcquisitionTrackerTransformation } from './state/useAcquisitionTrackerTransformation'

const AcquisitionTracker = (): JSX.Element => {
  const state = useAcquisitionTrackerPageState()
  const transformedState = useAcquisitionTrackerTransformation(
    state.initiatives
  )
  const lastUpdated = state.initiatives.reduce(
    (latest, initiative) =>
      latest > initiative.lastUpdated ? latest : initiative.lastUpdated,
    state.initiatives[0]?.lastUpdated
  )

  return (
    <>
      {state.isFetching ? (
        <AcquisitionTrackerPageSkeleton />
      ) : (
        <Page state={transformedState} lastUpdated={lastUpdated} />
      )}
    </>
  )
}

export { AcquisitionTracker }
